<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <!-- <i class="material-icons">perm_identity</i> -->
              <img
                class="img--icon"
                [src]="driverImgUrl"
                (click)="openModalImg('imgDriver')"
              />
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">
              Profile
              <!-- <small class="category">Complete su perfil</small> -->
            </h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="firstname"
                      >Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="firstname"
                      formControlName="firstname"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('firstname')"
                    >
                      El nombre es requerido
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="lastname"
                      >Lastname</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="lastname"
                      formControlName="lastname"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      El apellido es requerido
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="birthdate"
                      >Birthdate</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="birthdate"
                      formControlName="birthdate"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="address"
                      >Address</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="address"
                      formControlName="address"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="apt">Apt/Ste</label>
                    <input
                      type="text"
                      class="form-control"
                      id="apt"
                      formControlName="apt"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="city">City</label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      formControlName="city"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="state">State</label>
                    <input
                      type="text"
                      class="form-control"
                      id="state"
                      formControlName="state"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="zip">Zip</label>
                    <input
                      type="text"
                      class="form-control"
                      id="zip"
                      formControlName="zip"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="country"
                      >Country</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="country"
                      formControlName="country"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="username"
                      >Email</label
                    >
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        formControlName="username"
                        [readOnly]="!update"
                      />
                      <button
                        class="btn btn-sm btn-outline-dark"
                        type="button"
                        (click)="openEmail(form.get('username')?.value)"
                        title="Send email"
                      >
                        <i class="fas fa-envelope"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-5 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="indicative"
                      >Indicative</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="indicative"
                      formControlName="indicative"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
                <div class="col-7 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="phone">Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div
                      class="custom-control custom-checkbox status-check mt-4 checkbox"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="runner"
                        formControlName="runner"
                      />
                      <label class="custom-control-label" for="runner"
                        >Runner</label
                      >
                    </div>

                    <div
                      class="custom-control custom-checkbox status-check mt-4 checkbox"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="handler"
                        formControlName="handler"
                      />
                      <label class="custom-control-label" for="handler"
                        >Handler</label
                      >
                    </div>
                  </div>
                </div>

                <div class="col-md-6 d-flex justify-content-center">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input suspended"
                        id="suspended"
                        formControlName="suspended"
                      />
                      <label
                        class="custom-control-label suspended"
                        for="suspended"
                        >Suspended</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div class="row mb-6 justify-content-center">
                <div class="col-md-12 text-center">
                  <!-- class="btn btn-dark btn-sm btn-step" -->
                  <a
                    [ngClass]="{
                      btn: true,
                      'btn-sm': true,
                      'btn-dark': true,
                      'btn-step': step !== 1,
                      'btn-step__selected': step === 1,
                    }"
                    (click)="changeStep(1)"
                  >
                    License
                  </a>
                  <a
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 2,
                    'btn-step__selected': step === 2,
                  }"
                    (click)="changeStep(2)"
                  >
                    Vehicles
                  </a>
                  <a
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 3,
                    'btn-step__selected': step === 3,
                  }"
                    (click)="changeStep(3)"
                  >
                    Bank
                  </a>
                  <a
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 4,
                    'btn-step__selected': step === 4,
                  }"
                    (click)="changeStep(4)"
                  >
                    ID #
                  </a>
                  <a
                    [ngClass]="{
                    btn: true,
                    'btn-sm': true,
                    'btn-dark': true,
                    'btn-step': step !== 5,
                    'btn-step__selected': step === 5,
                  }"
                    (click)="changeStep(5)"
                  >
                    History
                  </a>
                </div>
              </div>
              <br />

              <!-- license -->
              <div class="row" formGroupName="driverFields" *ngIf="step == 1">
                <div class="col-12">
                  <h4 class="title">License</h4>
                </div>
                <div class="row row_data" formGroupName="license">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="licenseNumber"
                        >Driver's license number</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="licenseNumber"
                        formControlName="licenseNumber"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="state"
                        >State</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="state"
                        formControlName="state"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="formattedDate"
                        >Expiration date</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="formattedDate"
                        formControlName="formattedDate"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6 d-flex align-items-center text-center">
                    <a
                      (click)="openModalImg('imgLicense')"
                      target="_blank"
                      class="viewImgs"
                      >License</a
                    >
                  </div>
                </div>
              </div>

              <!-- vehiculo -->
              <div class="row" formGroupName="driverFields" *ngIf="step == 2">
                <div class="col-12">
                  <h4 class="title">Vehicles ({{ vehicles.length }})</h4>
                </div>
                <!-- <div class="row" formGroupName="vehicles"> -->
                <div
                  class="row row_data"
                  formArrayName="vehicles"
                  *ngFor="let vehicle of vehicles.controls; let i = index"
                >
                  <div class="col-md-12 text-center" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="name"
                        ># {{ i + 1 }}</label
                      >
                    </div>
                  </div>
                  <div class="col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="name"
                        >Name on car registration</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        formControlName="name"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="make">Make</label>
                      <input
                        type="text"
                        class="form-control"
                        id="make"
                        formControlName="make"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="model"
                        >Model</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="model"
                        formControlName="model"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="year">Year</label>
                      <input
                        type="text"
                        class="form-control"
                        id="year"
                        formControlName="year"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="size">Size</label>
                      <input
                        type="text"
                        class="form-control"
                        id="size"
                        formControlName="size"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="color"
                        >Color</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="color"
                        formControlName="color"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-6 col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="plate"
                        >Plate</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="plate"
                        formControlName="plate"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="insuranceCompany"
                        >Insurance company</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="insuranceCompany"
                        formControlName="insuranceCompany"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="policy"
                        >Policy</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="policy"
                        formControlName="policy"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-md-3 d-flex align-items-center">
                    <!-- <a [href]="getCardVehicle(i)" target="_blank">View Card</a> -->
                    <a
                      (click)="getCardVehicle(i)"
                      target="_blank"
                      class="viewImgs"
                      >Ins.</a
                    >
                  </div>
                  <div class="col-md-3 d-flex align-items-center">
                    <!-- <a [href]="getRegVehicle(i)" target="_blank"
                      >View Registration</a
                    > -->
                    <a
                      (click)="getRegVehicle(i)"
                      target="_blank"
                      class="viewImgs"
                      >Registration</a
                    >
                  </div>
                  <!-- Línea divisora entre vehículos -->
                  <div class="col-12">
                    <hr class="bg-dark border-0 my-4" />
                  </div>
                </div>
              </div>

              <!-- bank -->
              <div class="row" formGroupName="driverFields" *ngIf="step == 3">
                <div class="col-12">
                  <h4 class="title">Bank</h4>
                </div>
                <div class="row row_data" formGroupName="bank">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="name"
                        >Bank name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        formControlName="name"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="number"
                        >Routing number</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="number"
                        formControlName="number"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="account"
                        >Account number</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="account"
                        formControlName="account"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="aba"
                        >ABA</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="aba"
                        formControlName="aba"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                </div>
                <div class="row row_data" formGroupName="bank">
                  <div
                    class="col-md-6"
                    formGroupName="zelle"
                    *ngIf="
                      form.get('driverFields.bank.zelle.emailOrPhone')?.value
                    "
                  >
                    <div class="form-group">
                      <label class="bmd-label-floating" for="zelle">Zelle</label
                      ><img
                        src="assets/img/zelle.png"
                        class="img--zelle"
                        alt="z"
                      />
                      <input
                        type="text"
                        class="form-control"
                        id="emailOrPhone"
                        formControlName="emailOrPhone"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    formGroupName="venmo"
                    *ngIf="
                      form.get('driverFields.bank.venmo.emailOrPhone')?.value
                    "
                  >
                    <div class="form-group">
                      <label class="bmd-label-floating" for="venmo">Venmo</label
                      ><img
                        src="assets/img/venmo.png"
                        class="img--payment"
                        alt="v"
                      />
                      <input
                        type="text"
                        class="form-control"
                        id="emailOrPhone"
                        formControlName="emailOrPhone"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    formGroupName="applepay"
                    *ngIf="
                      form.get('driverFields.bank.applepay.emailOrPhone')?.value
                    "
                  >
                    <div class="form-group">
                      <label class="bmd-label-floating" for="applepay"
                        >Apple Pay</label
                      ><img
                        src="assets/img/applePay.png"
                        class="img--apple"
                        alt="ap"
                      />
                      <input
                        type="text"
                        class="form-control"
                        id="emailOrPhone"
                        formControlName="emailOrPhone"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    formGroupName="paypal"
                    *ngIf="
                      form.get('driverFields.bank.paypal.emailOrPhone')?.value
                    "
                  >
                    <div class="form-group">
                      <label class="bmd-label-floating" for="paypal"
                        >Paypal</label
                      ><img
                        src="assets/img/paypal.png"
                        class="img--payment"
                        alt="p"
                      />
                      <input
                        type="text"
                        class="form-control"
                        id="emailOrPhone"
                        formControlName="emailOrPhone"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- social security -->

              <div class="row" formGroupName="driverFields" *ngIf="step == 4">
                <div class="col-12">
                  <h4 class="title">Social security</h4>
                </div>
                <div class="row row_data" formGroupName="background">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="number"
                        >Social security or ITIN number</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="number"
                        formControlName="number"
                        [readOnly]="!update"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!--History  -->
              <div class="row" *ngIf="step == 5">
                <div class="col-12">
                  <h4 class="title">History</h4>
                </div>
                <div class="col-12">
                  <div class="row mb-3">
                    <div class="col-md-8">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search reference"
                          (input)="searchService($event)"
                          autocomplete="off"
                        />
                        <span class="input-group-text bg-transparent"
                          ><i class="fas fa-search text-dark"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="grid"
                  *ngFor="let service of searchedService; index as i"
                >
                  <div
                    *ngIf="service['data'][0].when['nameService'] != 'RUNNER'"
                  >
                    <div class="row">
                      <div class="col-4">
                        <label class="labelHeader">{{
                          service["data"][0].when["nameService"]
                        }}</label>
                      </div>
                      <div class="col-4 centerText">
                        <label class="labelHeader2">{{ service["ref"] }}</label>
                      </div>
                      <div class="col-4 textRight">
                        <label class="labelHeader1">{{
                          formatDate(service["createdAt"])
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-2">
                        <label class="labelFrom">From:</label>
                      </div>
                      <div class="col">
                        <label class="address">{{
                          service["data"][0].fullAddress
                        }}</label>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2">
                        <label class="labelTo">To:</label>
                      </div>
                      <div class="col">
                        <label class="address">{{
                          service["data"][0]["listDrop"][0].fullAddress
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row rows">
                      <div class="col-6">
                        <label class="label__total pl-1"
                          >Total: {{ service["commission"] }}
                        </label>
                      </div>
                      <div class="col-6 text-right">
                        <label
                          class="label__total pr-1"
                          (click)="getDataService(service['_id'])"
                          >Full receipt</label
                        >
                      </div>
                      <!-- <div class="col-2 textRight">
                        <ion-icon
                          class="iconShare"
                          name="share-social-outline"
                        ></ion-icon>
                      </div> -->
                    </div>
                  </div>

                  <div
                    *ngIf="
                      service['data'][0]['when']['nameService'] == 'RUNNER'
                    "
                  >
                    <div class="row">
                      <div class="col-4">
                        <label class="labelHeader">RUNNER</label>
                      </div>
                      <div class="col-4 centerText">
                        <label class="labelHeader2">{{ service["ref"] }}</label>
                      </div>
                      <div class="col-4 textRight">
                        <label class="labelHeader1">{{
                          formatDate(service["createdAt"])
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-2">
                        <label class="labelFrom"
                          >{{
                            getNumber(service["originalIndex"])
                          }}
                          Stop:</label
                        >
                      </div>
                      <div class="col">
                        <label class="address">{{
                          service["data"][0].fullAddress
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row rows">
                      <div class="col-6">
                        <label class="label__total pl-1"
                          >Total: {{ service["commission"] }}
                        </label>
                      </div>
                      <div class="col-6 text-right">
                        <label
                          class="label__total pr-1"
                          (click)="getDataService(service['_id'])"
                          >Full receipt</label
                        >
                      </div>
                      <!-- <div class="col-2 textRight">
                        <ion-icon
                          class="iconShare"
                          name="share-social-outline"
                        ></ion-icon>
                      </div> -->
                    </div>
                  </div>
                  <!-- modal -->
                </div>
              </div>

              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-update"
                    [disabled]="form.invalid || isLoading"
                  >
                    {{ id ? "Update" : "" }}
                  </button>
                  <button class="btn btn-dark btn-update" (click)="back()">Back</button>
                </div>
              </div>

              <div class="clearfix"></div>
            </form>
            <!-- <button (click)="pru()">pru</button> -->
            <!-- Modal service detail-->
            <div
              class="modal fade"
              tabindex="-1"
              [ngClass]="{ 'show d-block': showModal }"
            >
              <!-- style="background-color: rgba(0,0,0,0.5);" -->
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close btn btn-link btn-sm btn-close"
                      (click)="closeModal()"
                    >
                      &times;
                    </button>
                  </div>
                  <div class="modal-body">
                    <div>
                      <div class="row">
                        <div class="col-6">
                          <label class="labelHeaderModal"
                            ><strong>{{ data.nameService }}</strong></label
                          >
                        </div>
                        <div class="col-6 text-right">
                          <label class="labelHeader1">{{
                            formatDate(data.createdAt)
                          }}</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-6">
                          <label
                            >Stops : {{ data.listDropAddress.length }}
                          </label>
                        </div>
                        <div class="col-6 text-right">
                          <label>Ref #: {{ data.ref }}</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <p class="paragraph">
                            From:
                            <label class="address">{{ data.address }}</label>
                          </p>
                          <p
                            *ngIf="data.listDropAddress.length == 1"
                            class="paragraph3"
                          >
                            To:
                            <label class="address2">{{
                              data.listDropAddress
                            }}</label>
                          </p>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.listDropAddress.length > 1">
                        <div class="col">
                          <p
                            class="paragraph1"
                            *ngFor="let address of data.listDropAddress"
                          >
                            To:
                            <label class="address2">{{ address }}</label>
                          </p>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col-6">
                          <label
                            >1 Pick Up / {{ data.listDropAddress.length }} Drop
                            Off</label
                          >
                        </div>
                        <div class="col-6 text-right">
                          <label>Ref #: {{ data.ref }}</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col-6">
                          <label>Pick up time: {{ data.pickUptime }} </label>
                        </div>
                        <div class="col-6 text-right">
                          <label>Drop off: {{ data.dropOffTime }}</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <label>Booking Fee: USD $5.00</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <label> 3-mile fixed fee :USD $30.00</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col">
                          <label> Miles extra (1 mile = USD $1.20): 9 mi</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <label> Total miles : {{ data.distance }}</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col">
                          <label> Tip : </label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-6">
                          <label class="time">
                            Arrival time: {{ data.timeStop }}
                          </label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-12">
                          <label class="time">
                            Things To-Do time spent : 1 hour, USD $50.00
                          </label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-7">
                          <label> Total: USD $ {{ data.price }} </label>
                        </div>

                        <div class="col-5">
                          <i class="fa-solid fa-credit-card iconCard"></i>
                          <label class="labelCard"> visa: </label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-12">
                          <label> Things To-Do Runner : Juan Garcia </label>
                        </div>
                      </div>

                      <div class="row">
                        <div
                          class="col-7"
                          *ngIf="data.nameService !== 'RUNNER'"
                        >
                          <label> Driver: Juan Garcia </label>
                        </div>
                        <div class="col-5">
                          <label class="ratingPlate"> Rating: </label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-7">
                          <label> White Hyundai 2020 Santa Fe</label>
                        </div>
                        <div class="col-5">
                          <label class="ratingPlate"> Plate : 96P463 FL </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal imgs-->
            <div
              class="modal fade"
              tabindex="-1"
              [ngClass]="{ 'show d-block': showModalImg }"
              style="background-color: rgba(0, 0, 0, 0.5)"
            >
              <!-- style="background-color: rgba(0,0,0,0.5);" -->
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header modal-close">
                    <button
                      type="button"
                      class="btn btn-link btn-sm btn-close"
                      (click)="closeModalImg()"
                    >
                      &times;
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img [src]="imgModal" class="modal--imgs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4">
        <div class="card card-profile">
          <div class="card-avatar">
            <img
              class="img"
              [src]="driverImgUrl"
              style="cursor: pointer"
              (click)="viewDriverImgUrl()"
            />
          </div>
          <div class="card-body">
            <h6 class="card-category text-gray">User profile</h6>
            <h4 class="card-title">
              {{ form.get("firstname")?.value }}
              {{ form.get("lastname")?.value }}
            </h4>
             <p class="card-description">
            Aquí puedes editar los datos del usuario. Los cambios se
            reflejarán en el sistema.
          </p> 
            <br /><br />
            <img
              [src]="imgDriver"
              class="imgs"
              (click)="openModalImg('imgDriver')"
            />
            <br /><br />
            <img
              [src]="img"
              class="img--driver"
              (click)="openModalImg('img')"
            />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
